import clsx from 'clsx';

import { TagIcon, XMarkIcon } from '@/resources';
import { AssetTagItemProps } from '@/types';

export const AssetTagItem = ({
  tag,
  handleTagRemove,
  className,
  icon,
  isRemovable = true
}: AssetTagItemProps) => {
  const Icon = icon ?? TagIcon;
  return (
    <div
      key={tag?.value as number}
      className={clsx(
        'mx-2 flex flex-row items-center rounded-xl bg-primary-gray p-1 px-3 text-xs font-bold text-primary-blue',
        className
      )}>
      <Icon className='mr-2 w-3' />
      {tag?.label}
      {isRemovable && (
        <XMarkIcon className='ml-2 w-2 cursor-pointer' onClick={() => handleTagRemove?.(tag)} />
      )}
    </div>
  );
};
